import { useEffect, useRef, useState } from "react";
import { useModal } from "../../../context/ModalContext";
import { useFileNavigator } from "../../../context/FileNavigator";
import { getButtonsCancelOk } from "../../../context/helpers/helperModalContext";
import * as apiFN from "../../../api/apiFileNavigator";
import { useTranslation } from "react-i18next";
import { useToast } from "../../../context/ToastContext";
import { handleInputFileName } from "../../../utils/helpers/handleInputMaks";

const CreateFile = ({ showCreateFileDlg, setShowCreateFileDlg }) => {

    const { t } = useTranslation(['FileNavigator', 'common']);
    const { showDlg, hideDlg } = useModal();
    const { stateFN, dispatchFN, fetchDataFN } = useFileNavigator();

    const { showToast } = useToast();
    const refInputNewFile = useRef();
    const refFormNewFolder = useRef();
 
    // JSX форми діалогу створення папки
    const htmlModel = (
        <form ref={refFormNewFolder}
            onSubmit={(e) => handleSubmitCreateFolder(e)}>
            <div className="mb-3">
            <label className="form-label" >
                {t('newFileName')}
            </label>
            <input type="text" 
                ref={refInputNewFile}
                defaultValue=""
                className="form-control"
                onInput={()=>handleInputFileName(refInputNewFile)}
                required />
            <small id="emailHelp" className="form-text text-muted">
                {t('createIn')}: {`Root${stateFN.currentPathFN}`}
            </small>
            </div>
        </form>
    ); 

    // Параметри кнопок діалогу створення папки
    const paramsCreateDlg = {
        title: t('popupCreateFilter'),
        buttons: [...getButtonsCancelOk(t)],
        type: "confirm",
        text: htmlModel,
        refFirstFocus: refInputNewFile 
    };

    // Подія субміту на кнопку ОК
    paramsCreateDlg.buttons[1].handleClick = () => {
        refFormNewFolder.current.requestSubmit();
    }
 
    // Створення папки - подія submit форми діалогу
    const handleSubmitCreateFolder = (e) => {
        e.preventDefault();
        hideDlg(false)
        createFile();
    }

    const createFile = async () => {
        dispatchFN({type:'SET_DATA_FN', payload:null});
        const createFileData = {
            currentPath : stateFN.currentPathFN,
            fileName    : refInputNewFile.current.value
        }

        console.log(createFileData);
        const resCreate = await apiFN.createEmptyFile(createFileData);
        
        (resCreate)
            ? showToast(t('messFileCreate'), 'success')
            : showToast(t('common:messError'), 'danger');

        fetchDataFN(true);
    }

    useEffect(() => {
        // Показуємо діалог якщо showCreateFolderDlg
        // та скидаємо showCreateFolderDlg
        if (showCreateFileDlg === true) {
            showDlg(paramsCreateDlg);
            setShowCreateFileDlg(false);
        }
    }, [showCreateFileDlg]);

    return <></>;
};

export default CreateFile;
